module.exports = __webpack_public_path__ + "img/ga-v4-mini.bdb61c4a.jpeg";